import {
  locationSearchSubmit,
  locationSearchWhenDesktop,
  locationSearchWhereDesktop,
} from '@bells/i18n';
import { Skeleton } from '../../../components/skeleton';
import { cn } from '@bells/core/lib/utils';
import { Search } from 'lucide-react';

export const LocationSearchPlaceholder = ({
  withSubmit,
  className,
  onlyMobile,
}: {
  withSubmit: boolean;
  className?: string;
  onlyMobile?: boolean;
}) => {
  return (
    <>
      <div
        className={cn('flex w-full flex-col gap-2', className, {
          'md:hidden': onlyMobile !== true,
        })}
      >
        <Skeleton className='h-[42px] w-full bg-[#ececec] dark:bg-[#242427]'></Skeleton>
        <Skeleton className='h-[42px] w-full bg-[#ececec] dark:bg-[#242427]'></Skeleton>
        <Skeleton className='h-[42px] w-full bg-[#ececec] dark:bg-[#242427]'></Skeleton>

        {withSubmit && (
          <Skeleton className='h-[44px] w-full bg-[#ececec] dark:bg-[#242427]'></Skeleton>
        )}
      </div>

      <div
        className={cn(
          'relative hidden w-full grid-cols-[1fr_1fr_min-content] flex-wrap items-center gap-4 self-stretch rounded-xl border bg-background px-2',
          className,
          { 'md:grid': onlyMobile !== true }
        )}
      >
        <div className='relative flex h-full flex-1 items-center justify-between gap-1 border-b bg-transparent px-2 py-4 sm:border-b-0 sm:border-r'>
          <div className='flex flex-1 flex-col gap-1'>
            <label className='flex px-2 pt-2 text-sm font-semibold uppercase text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>
              {locationSearchWhereDesktop()}
            </label>
            <Skeleton className='h-[40px] w-full'></Skeleton>
          </div>
        </div>

        <div className='relative flex h-full flex-1 flex-nowrap items-center justify-between gap-2 px-2 py-4'>
          <div className='flex flex-1 flex-col gap-1'>
            <label className='flex px-2 pt-2 text-sm font-semibold uppercase text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>
              {locationSearchWhenDesktop()}
            </label>
            <Skeleton className='h-[40px] w-full'></Skeleton>
          </div>
        </div>

        {withSubmit && (
          <div className='relative flex h-full min-h-full flex-nowrap items-center justify-between gap-2 place-self-stretch border-l px-2 pl-4'>
            <div className='inline-flex h-12 w-auto items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-primary px-3 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 xl:px-4 [&_svg]:pointer-events-none [&_svg]:size-6 [&_svg]:shrink-0'>
              <Search></Search>
              <span className='hidden xl:block'>{locationSearchSubmit()}</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
